<div class="container">
    <div class="row crud-header w-100 justify-content-center">
        <div class="col-auto d-flex align-items-center gap-3">
            <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                 class="controls-left-button"
                 matTooltip="Terug naar projectenkaart"
                 matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">Medewerker Activiteit Statistieken</h1>
        </div>
        <div class="col-auto d-flex align-items-center gap-2">
            <label for="weeks-selector">Tijdsperiode:</label>
            <select id="weeks-selector"
                    #weeksSelect
                    [value]="numberOfWeeks()"
                    (change)="onWeeksChange(+weeksSelect.value)"
                    class="weeks-selector">
                <option value="1">1 Week</option>
                <option value="2">2 Weken</option>
                <option value="4">4 Weken</option>
                <option value="8">8 Weken</option>
                <option value="12">12 Weken</option>
            </select>
            <span class="date-range">
                ({{ startDate() | date : 'dd-MM-yyyy' }} tot {{ endDate() | date : 'dd-MM-yyyy' }})
            </span>
        </div>
    </div>

    @if (data().length > 0) {
        <div class="table-container d-flex justify-content-center">
            <table class="insight-table">
                <thead>
                    <tr>
                        <th class="user-column">Medewerker</th>
                        @for (week of uniqueWeeks(); track week) {
                            <th class="week-column">{{ week }}</th>
                        }
                        <th class="total-column">Totaal</th>
                    </tr>
                </thead>
                <tbody>
                    @for (user of tableData(); track user.userId) {
                        <tr>
                            <td class="user-cell">{{ user.userName }}</td>
                            @for (week of uniqueWeeks(); track week) {
                                <td class="count-cell"
                                    [style.background-color]="getCellBackgroundColor(getCountForUserAndWeek(user, week))"
                                    [title]="user.userName + ' - ' + week + ': ' + getCountForUserAndWeek(user, week) + ' oproepen'">
                                    {{ getCountForUserAndWeek(user, week) }}
                                </td>
                            }
                            <td class="total-cell"
                                [title]="user.userName + ' - Totaal: ' + (user.weekCounts | sum) + ' oproepen'">
                                {{ user.weekCounts | sum }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    } @else {
        <div class="no-data d-flex justify-content-center">
            <p>Geen gegevens beschikbaar voor de geselecteerde {{ numberOfWeeks() }} wek{{ numberOfWeeks() > 1 ? 'en' : '' }} periode.</p>
        </div>
    }
</div>
